export default "__VITE_ASSET__CCCANgBQ__"